import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Breadcrumb,
  useLocalization,
  useURLParamsDynamically,
  useStore,
} from '@ui-framework/index';
import {
  IconLibrary,
  Layout,
  StackablePageButtons,
  SJForm,
} from '@product-framework/index';
import DuplicateJobDialog from '@product-framework/components/Dialogs/DuplicateJobDialog';
import { useState } from 'react';

function ServiceJobEdit() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [serviceJob, setServiceJob] = useState(null);
  const { id: pageId } = useParams();
  const store = useStore();
  const urlParams = useURLParamsDynamically();

  const breadCrumb = [
    {
      name: formatMessage({
        id: 'DASHBOARD_BREADCRUMB',
        defaultMessage: 'Dashboard',
      }),
      icon: IconLibrary.Dashboard,
      onClick: () => {
        navigate('/dashboard');
      },
    },
    {
      name: formatMessage({
        id: 'SERVICEJOBS_BREADCRUMB',
        defaultMessage: 'Jobs',
      }),
      permissionName: 'LIST_JOBS',
      icon: IconLibrary.ServiceJobs,
      onClick: () => {
        store.domain.list.reset('ServiceJobList');
        navigate('/servicejobs');
      },
    },
    {
      name: formatMessage({
        id: 'SERVICEJOB_BREADCRUMB',
        defaultMessage: 'Job',
      }),
      icon: IconLibrary.ServiceJob,
      onClick: undefined,
    },
  ];

  const stackablePageButtons = [
    // TODO: This is in backlog to implement when needed
    // {
    //   label: formatMessage({
    //     id: 'DUPLICATE_SERVICEJOB_STACKABLE_BUTTON',
    //     defaultMessage: 'Duplicate Job',
    //   }),
    //   permissionName: 'DUPLICATE_JOB',
    //   Icon: IconLibrary.ServiceJob,
    //   variant: 'outlined',
    //   onClick: () => setOpen(true),
    // },
    {
      label: formatMessage({
        id: 'CREATE_SERVICEJOB_STACKABLE_BUTTON',
        defaultMessage: 'Create Job',
      }),
      permissionName: 'CREATE_JOB',
      Icon: IconLibrary.ServiceJob,
      variant: 'outlined',
      onClick: () => navigate('/servicejobs/preregister'),
    },
    {
      label: formatMessage({
        id: 'EDIT_SERVICEJOBS_STACKABLE_BUTTON',
        defaultMessage: 'List Jobs',
      }),
      permissionName: 'LIST_JOBS',
      Icon: IconLibrary.ServiceJobs,
      variant: 'outlined',
      onClick: () => {
        store.domain.list.reset('ServiceJobList');
        navigate('/servicejobs');
      },
    },
  ];

  let action = 'EDIT';
  if (urlParams?.status === 'pendingacceptancejob') {
    action = 'EMAIL';
  }

  return (
    <Layout>
      <Grid2 container mb={1.5}>
        <Grid2 xs={12} md={6}>
          <Breadcrumb items={breadCrumb} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      <SJForm
        action={action}
        key={pageId}
        onReady={job => setServiceJob(job)}
      />
      <DuplicateJobDialog
        open={open}
        onClose={() => setOpen(false)}
        serviceJob={serviceJob}
      />
    </Layout>
  );
}

export default observer(ServiceJobEdit);
